export default __webpack_public_path__ + "assets/Reporter2.png";